import { Component, OnInit, OnDestroy, ViewChild, PLATFORM_ID, ChangeDetectionStrategy, ChangeDetectorRef, ViewContainerRef } from '@angular/core';
import { DomSanitizer, Title, Meta } from '@angular/platform-browser';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Generic } from './generic.model';
import { GenericService } from './generic.service';
import { NavigationService } from '../shared/navigation/navigation.service';
import { Subscription, fromEvent } from 'rxjs';
import { distinctUntilChanged, map, debounceTime, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Page } from '../shared/navigation/pages.model';

@Component({
  selector: 'app-generic-details',
  templateUrl: 'generic-details.component.html',
  styleUrls: ['generic-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class GenericDetailsComponent implements OnInit, OnDestroy {

  public cdn = environment.cdn;
  public path: string;
  public pageTitle: string;
  public pageContent: string;
  public generic: Generic;
  public genericContent: any[] = [];
  public path_list = '/';
  public path_details = '/';
  public page_details: any;
  public stickTop = 0;

  constructor(private route: ActivatedRoute, private router: Router, private navigationService: NavigationService, private genericService: GenericService, private cdr: ChangeDetectorRef) {
    this.page_details = this.router.config.find(r => r.data?.module === 'GenericDetailsModule');  
    this.path_details = this.page_details?.data.path || '/';  
    this.path_list = this.router.config.filter(r => r?.data?.module === 'GenericModule').reduce((prev, curr) => (prev.data.level < curr.data.level) ? prev : curr)?.path || '/';
  }

  ngOnInit() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.path = params.get('path');
      this.generic = null;
      this.genericContent = [];
      this.loadData();
    });
    this.pageTitle = this.route.snapshot.data.name;
    this.pageContent = this.route.snapshot.data.content;
  }

  loadData() {
    this.genericService.item(this.path).pipe(take(1)).subscribe(generic => {
      this.generic = generic;
      if (this.generic.photos) {
        const banner = this.generic.photos.find(f => f.banner == 1);
        if (banner) this.generic.banner = this.cdn+'/generics/'+generic.photos_directory+'/'+banner.filename
      }

      let fbimage;
      if (this.generic.photos) {
        fbimage = this.generic.photos.find(f => f.logo == 1);
      }

      this.navigationService.setMeta(
        (this.generic.meta_title ? this.generic.meta_title : this.generic.name),
        (this.generic.meta_keywords ? this.generic.meta_keywords : this.generic.name),
        (this.generic.meta_description ? this.generic.meta_description : this.generic.name),
        environment.base + '/'+this.path_details+'/' + this.generic.path,
        (fbimage ? this.cdn+'/generics/'+generic.photos_directory+'/'+fbimage.filename : null)
      );

      generic.categories = [];
      if (this.page_details) {generic.categories.push(this.page_details.data)}
      this.navigationService.currentPage.next(generic);
      this.cdr.detectChanges();
    }, error => {
      if (error.status === 404) {
        this.router.navigate(['404']);
      } else {
        // console.log(error);
      }
    });
  }

  changeModel(data) {
    this.generic[data.field] = data.value;
  }

  ngOnDestroy() {
  }

}
